import { Admin, Superadmin } from "@ambii-com/core";
import { DocumentSnapshot } from "@firebase/firestore-types";
import {
  liteCollections,
  liteGetDocument,
  liteQueryCollectionLimited,
} from "~/utils/firestoreLite";

export async function readAdmin(userId: string): Promise<Admin> {
  return liteGetDocument(liteCollections.admins, userId).then(Admin.fromDoc);
}

export async function readSuperadmin(userId: string): Promise<Superadmin> {
  return liteGetDocument(liteCollections.superadmins, userId).then(
    Superadmin.fromDoc
  );
}

export async function readAdminData(
  userId: string
): Promise<Record<string, unknown>> {
  const doc = await liteGetDocument(liteCollections.admins, userId);
  return doc.data() as Record<string, unknown>;
}

export async function readAdminByUserId(
  userId: string
): Promise<DocumentSnapshot | undefined> {
  const docs = await liteQueryCollectionLimited(
    liteCollections.admins,
    1,
    ["uid", "==", userId]
  );
  return docs[0];
}

export async function readSuperadminByUserId(
  userId: string
): Promise<DocumentSnapshot | undefined> {
  const doc = await liteGetDocument(liteCollections.superadmins, userId);
  return doc.exists ? doc : undefined;
}
